import * as Phaser from "phaser-ce"

export class AudioSync {

    private checks: Array<SyncCheck> = []
    private playing = false
    private offset = 0
    private timer: Phaser.Timer
    private audio: Phaser.Sound

    constructor(private game: Phaser.Game, audio: Phaser.Sound | string) {
        if (audio instanceof Phaser.Sound) {
            this.audio = audio
        } else {
            this.audio = game.add.audio(audio)
        }
        this.timer = this.game.time.create()
    }

    /**
     * @param {number} offset added to the delay for all subsequent added items.
     */
    setOffset = (offset: number) => {
        this.offset = offset
    }

    add = (delay: number, callback: () => void) => {
        if (this.playing) {
            throw new Error("Can't add events to AudioSync that is running.")
        }
        this.checks.push(new SyncCheck(delay + this.offset, callback))
    }

    onStop = (callback: () => void) => this.audio.onStop.addOnce(callback)

    start = () => {
        this.playing = true
        this.checks.sort(SyncCheck.compareSyncs)

        this.timer.loop(50, () => {
            this.checkChecks()
            if (this.checks.length === 0) {
                this.timer.destroy()
            }
        })
        this.timer.start()
        this.audio.play()
    }

    /**
     * Like stop except any added on stops will not be executed.
     */
    destroy = () => {
        this.timer.destroy()
        this.audio.onStop.removeAll()
        this.audio.stop()
    }

    stop = () => {
        this.timer.destroy()
        this.audio.stop()
    }

    private checkChecks = () => {
        const check = this.checks[0]
        if (check && this.audio.currentTime > check.delay) {
            check.callback()
            this.checks.shift()
            this.checkChecks()
        }
    }
}

class SyncCheck {
    delay: number
    callback: () => void

    constructor(delay: number, callback: () => void) {
        this.delay = delay
        this.callback = callback
    }

    static compareSyncs = (syncA: SyncCheck, syncB: SyncCheck): number => {
        if (syncA.delay === syncB.delay) {
            return 0
        }
        if (syncA.delay < syncB.delay) {
            return -1
        } else {
            return 1
        }
    }

    toString = (): string => {
        return "SyncCheck delay: " + this.delay
    }
}
